import { toValue } from "vue";

// First row of the patient inputs. The Classification inputs sit beside that row and reserve the
// same header height, so both sides read this one list.
export const PATIENT_IDENTITY_ROW_FIELDS = ["firstName", "lastName", "phoneNumber", "dob"];

export const useGuessMetadata = (patientGuess) => {
  const guessMetaData = (field) => toValue(patientGuess)?.[`${field}MetaData`];

  const rowGuessMeta = (fields) => fields.some((field) => guessMetaData(field));

  return { guessMetaData, rowGuessMeta };
};
